import React from 'react';
import ComplianceRulebookSection from '../../../sections/AdminDashboard/ComplianceRulebook/ComplianceRulebook';

const ComplianceRulebook = () => {
  return <ComplianceRulebookSection />;
};

export default ComplianceRulebook;

